<nav class="navbar navbar-expand-lg navbar-light bg-dark p-0">
    <div class="container">
        <a class="navbar-brand" href="/kontrol" aria-label="Bootstrap">
            <img [src]="environment.assetBase + '/assets/img/10-4-admin.png'" class="img-fluid" width="45"
                 height="45"></a>
        <div class="collapse navbar-collapse" id="navbarScroll">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item"><a class="nav-link" [routerLink]="'/kontrol'">Forside</a></li>
                <li class="nav-item"><a class="nav-link" [routerLink]="'/kontrol/shipment-control'">Kontrol</a></li>
                <li class="nav-item"><a class="nav-link" [routerLink]="'/kontrol/picking-list'">Plukliste</a></li>
                <li class="nav-item"><a class="nav-link" [routerLink]="'/kontrol/shipment-utilities'">End of Day</a>
                </li>
                <li class="nav-item"><a class="nav-link" [routerLink]="'/kontrol/shipment-control'"
                                        [queryParams]="{dbMode: true}">Søg vare</a></li>
                <li class="nav-item"><a class="nav-link" [routerLink]="'/kontrol/shipping-system-search'">Søg
                    forsendelse</a></li>
                <li class="nav-item"><a class="nav-link" [routerLink]="'/kontrol/shipping-system'">Forsendelser</a></li>
                <li class="nav-item">
                    <a class="nav-link position-relative" [routerLink]="'/notifications'">Notifications
                        <span *ngIf="unreadCount > 0" class="position-absolute start-100 translate-middle badge rounded-pill bg-danger">{{unreadCount}}</span>
                    </a>
                </li>

                <li><a class="nav-link position-relative">|</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/shipping-missing-coordinates" i18n>Missing coordinates</a></li>
                <li class="nav-item" *ngIf="permissionsService?.permissions?.Admin"><a class="nav-link" routerLink="/shipment-drivers" i18n>Drivers</a></li>
                <li class="nav-item" *ngIf="permissionsService?.permissions?.Admin"><a class="nav-link" routerLink="/shipment-routes" i18n>Routes</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/shipment-help">Info</a></li>
                <li><a class="nav-link position-relative">|</a></li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript:0" (click)="logout()" i18n>Logout</a>
                </li>
            </ul>
        </div>
    </div>
</nav>
